export function servicesRegisterStore(servicesDataKey) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'SEARCH_DATA_REGISTER_STORE',
                servicesDataKey,
            })
        );
}

export function servicesUnregisterStore(servicesDataKey) {
    return dispatch => {
        dispatch({type: 'SEARCH_DATA_UNREGISTER_STORE', servicesDataKey});
    };
}

export function servicesDataSearch(servicesDataKey) {
    return dispatch => {
        dispatch({type: 'SEARCH_DATA_SEARCH', servicesDataKey});
    };
}

export function getGlobalShelvesTree() {
    return dispatch => {
        dispatch({type: 'GLOBAL_SHELVES_TREE'});
    };
}

export function resetServiceData(servicesDataKey, actionShouldFetch = false) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'SEARCH_DATA_RESET',
                servicesDataKey,
                actionShouldFetch,
            })
        );
}

export function refreshServicesData(servicesDataKey, selectRecord = false) {
    return dispatch => {
        dispatch({
            type: 'SEARCH_DATA_REFRESH',
            actionShouldFetch: true,
            servicesDataKey,
            selectRecord,
        });
    };
}

export function setSort(servicesDataKey, sortColumn, order) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'SEARCH_DATA_SORT',
                servicesDataKey,
                order,
                sortColumn,
            })
        );
}

export function resetSort(servicesDataKey, clearSort = false, actionShouldFetch = false) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'SEARCH_DATA_SORT_RESET',
                servicesDataKey,
                clearSort,
                actionShouldFetch,
            })
        );
}

export function setFilter(servicesDataKey, targets, activeId = 'guid') {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'SEARCH_DATA_SET_FILTER',
                targets,
                activeId,
                servicesDataKey,
            })
        );
}

export function setQuery(servicesDataKey, query) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'SEARCH_DATA_SET_QUERY',
                query,
                servicesDataKey,
            })
        );
}

export function routerChanged(routerParams, nextRouterParams) {
    return dispatch => {
        dispatch({type: 'SEARCH_DATA_ROUTER_CHANGED', routerParams, nextRouterParams});
    };
}
